// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDX6ZjB0Wt9i3d82NNVJjfog7i8bEzhaao",
  authDomain: "morse-birwi.firebaseapp.com",
  projectId: "morse-birwi",
  storageBucket: "morse-birwi.firebasestorage.app",
  messagingSenderId: "88444855240",
  appId: "1:88444855240:web:22c4a54b587ed6daa856fd"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export default app;